module.exports = __webpack_public_path__ + "img/C04TechGalleyS_ua.14f620a8.webp";